import React, { Component } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment';
import { DatePicker } from 'material-ui-pickers';
import validation  from './../../constants/validation';

import 'react-datepicker/dist/react-datepicker.css'
import './material-design-iconic-font/css/material-design-iconic-font.css'
class DatePickerUI extends Component {
  static propTypes = {
    input: PropTypes.shape({
      onChange: PropTypes.func.isRequired,
      value: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired,
    }).isRequired,
    label: PropTypes.string,
    format: PropTypes.string,
    animateYearScrolling: PropTypes.bool,
    fullWidth: PropTypes.bool,
    invalidDateMessage: PropTypes.string,
    cancelLabel: PropTypes.string,
    clearLabel: PropTypes.string,
    minDateMessage: PropTypes.string,
  }

  static defaultProps = {
    format: 'LL',
    leftArrowIcon: <i className="zmdi zmdi-arrow-back" />,
    rightArrowIcon: <i className="zmdi zmdi-arrow-forward" />,
    animateYearScrolling: false,
    fullWidth: true,
    invalidDateMessage: 'Formato de fecha inválido',
    cancelLabel: 'Cancelar',
    clearLabel: 'Limpiar',
    minDateMessage: validation.NOT_TODAY
  }

  render() {
    const {
      input: { value, onBlur, onChange: onChangeProps, ...inputProps }, minDateMessage, label, format, disabled, onChange, leftArrowIcon, rightArrowIcon, animateYearScrolling, fullWidth,
      meta: { touched, error }, invalidDateMessage, cancelLabel, clearLabel,
      ...rest,
    } = this.props
    return (
      <React.Fragment>
        <DatePicker
          {...inputProps}
          value={value !== '' ? moment(value).startOf('day').toDate() : null}
          label={label}
          format={format}
          disabled={disabled}
          leftArrowIcon={leftArrowIcon}
          rightArrowIcon={rightArrowIcon}
          animateYearScrolling={animateYearScrolling}
          fullWidth={fullWidth}
          onChange={(value) => { onChangeProps(value); if (onChange) onChange(value) }}
          // onBlur={value => onBlur(value)}
          invalidDateMessage={invalidDateMessage}
          cancelLabel={cancelLabel}
          clearLabel={clearLabel}
          minDateMessage={minDateMessage}
          {...rest}
        />
        {touched && error && <span className="invalid-feedback" style={{ display: 'inherit' }}>{error}</span>}
      </React.Fragment>
    )
  }
}

export default DatePickerUI;



// WEBPACK FOOTER //
// ./src/components/DatePickerUI/index.js